<template>
 <div class="inner-wrapper">
    <div class="inner-wrapper-md">
  <div class="row">
    <div class="col-12">
      <h4 class="page-title">Account verified!</h4>
<AlertMessages />
      <p v-if="!this.hasError" class="body">
        Your account  <span class="label-active">{{this.Email}}</span> has been successfully verified. You can now sign in and start using our Sports safeguarding tool.</p>
      <div class="form-row cta-group">
        <router-link class="cta-white-227" :to="{ name: 'signin' }">
          Proceed to sign in <span class="angle-right-white"></span></router-link
        >
      </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>

import { mapActions, mapState,mapGetters } from "vuex";
import AlertMessages from "../components/alert-messages";

export default {
  name: "AccountVerification",
  components: { AlertMessages },
 
  async mounted() {
    this.clear();
    await this.verifyAccount({ key: this.$route.query.key });
  },
  methods:{
    ...mapActions("users", ["verifyAccount"]),
    ...mapActions("alert", ["clear"]),
  },
  computed:{
     ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),

      Email: {
      get() {
        return this.user.Email;
      }
    }
  },
 
};
</script>

<style lang="scss" scoped></style>
